var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCompany = function SvgCompany(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 12,
    "data-width-24": 18,
    viewBox: "0 0 12 13.4",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 0.7,
    d: "M.35 13h11.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7,
    d: "M1.334 12.683V.85a.5.5 0 0 1 .5-.5h8.333a.5.5 0 0 1 .5.5v11.833"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7,
    d: "M4.334 12.683v-3h3.333v3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 0.7,
    d: "M3.333 2.017h2v2h-2zM6.667 2.017h2v2h-2zM6.667 6.017h2v2h-2zM3.333 6.017h2v2h-2z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCompany);
export default ForwardRef;